import { Component, OnInit, ViewChild } from '@angular/core';

import { AppComponent } from 'src/app/app.component';
import { DateUtils } from 'src/app/utils/date-utils';
import { CustomForms } from '../../forms/custom-forms';
import { MainComponent } from '../../main/main.component';
import { environment } from 'src/environments/environment';

import { JqWidgets } from 'src/app/utils/jqWidgets';
import { jqxWindowComponent } from 'jqwidgets-ng/jqxwindow';

import { CiudadanosService } from 'src/app/services/ciudadanos/ciudadanos.service';

import { CiudadanoModel } from 'src/app/services/ciudadanos/models/ciudadano.model';

import { CiudadanosComponent } from '../ciudadanos.component';
import { SsoService } from 'src/app/services/sso/sso.service';

@Component({
  selector: 'app-ciudadanos-edit',
  templateUrl: './ciudadanos-edit.component.html',
  styleUrls: ['./ciudadanos-edit.component.css']
})
export class CiudadanosEditComponent extends CustomForms implements OnInit {
  @ViewChild('form') form: jqxWindowComponent;

  private componentRef = null;
  public environment = environment;
  public langGrid = JqWidgets.getLocalization('es');

  public ciudadano: CiudadanoModel;
  ciudadanoExist = false;

  public editando = false;

  guardar = false;

  // Para traducir los textos
  public translate(text: string): string {
    return AppComponent.translate(text);
  }

  formatDateTime(fecha){
    if(fecha){
      fecha = new Date(fecha);
    }

    return DateUtils.formatDateTime(fecha, true);
  }

  constructor(private ciudadanoService: CiudadanosService, private ssoService: SsoService) {
    super();
  }

  ngOnInit(): void {
    this.langGrid = JqWidgets.getLocalization(this.ssoService.getTicket().Usuario.Idioma.Codigo.substring(0, 2));
    this.guardar = false;
  }

  public init(componentRef: any, ciudadano: CiudadanoModel) {
    this.componentRef = componentRef;
    this.ciudadano = ciudadano ? ciudadano : new CiudadanoModel();

    if(!this.ciudadano.tarjetas){
      this.ciudadano.tarjetas = [];
    }

    if(this.ciudadano.fechaCreacion == null){
      this.ciudadano.fechaCreacion = new Date();
    }
  }

  async ngAfterViewInit(): Promise<void> {
    this.addCustomForm(this.form);
  }

  public onClose() {
    if (this.componentRef) {
      this.componentRef.destroy();
      CiudadanosComponent._this.form.expand();
    }
  }

  /*
    Cambia el estado de validación del ciudadano
  */
  onChangeValidado(event: any){
    if(event.target.checked){
      this.ciudadano.estadoValidacion = 1;
    }else{
      this.ciudadano.estadoValidacion = 0;
    }
  }

  /*
    Comprueba el email del ciudadano,
    si existe se muestra un mensaje de error
  */
  async checkCiudadano(event: any) {
    if(await this.ciudadanoService.checkCiudadanoExist(event.target.value)){
      this.ciudadanoExist = true;
    }else{
      this.ciudadanoExist = false;
    }
  }

  async onGuardar(event: any): Promise<void>{
    if(!this.ciudadanoExist || this.ciudadano.id){
      let ciudadano = await this.ciudadanoService.saveCiudadano(this.ciudadano);

      if(ciudadano != null){
        this.ciudadano = ciudadano;

        this.guardar = true;

        MainComponent.getInstance().showInfo(
          'ATENCION',
          'Registro_almacenado',
          2000
        );

        let t = setTimeout(() => {
          clearTimeout(t);
          this.guardar = false;

          let tClose = setTimeout(() => {
            clearTimeout(tClose);
            CiudadanosComponent._this.getCiudadanos();
            this.form.close();
          }, 500);
        }, 500);
      }else{
        MainComponent.getInstance().showError(
          'ATENCION',
          'Fallo_almacenar_info',
          2000
        );
      }
    }else{
      MainComponent.getInstance().showError(
        'ATENCION',
        'Revisa_campos_formulario',
        2000
      );
    }
  }
}
